import { z } from "zod";

export const contentFormatSchema = z.enum([
  "product_demo",
  "problem_solution",
  "social_proof",
  "comparison",
  "voiceover",
  "ai_presenter",
]);

export const contentStatusSchema = z.enum([
  "idea",
  "generating",
  "review",
  "approved",
  "scheduled",
  "published",
  "failed",
]);

export const brandProfileInputSchema = z.object({
  shopifyStoreDomain: z
    .string()
    .trim()
    .toLowerCase()
    .regex(
      /^[a-z0-9][a-z0-9-]*\.myshopify\.com$/,
      "Enter a valid myshopify.com store domain.",
    )
    .optional(),
  websiteUrl: z.url().optional(),
  audience: z.string().trim().max(500).default(""),
  brandVoice: z.string().trim().max(500).default(""),
  contentGoals: z.array(z.string().trim().min(1).max(80)).max(6).default([]),
  contentPillars: z
    .array(z.string().trim().min(1).max(80))
    .max(6)
    .default([]),
});

export const contentIdeaInputSchema = z.object({
  planId: z.string().uuid().optional(),
  contentPillar: z.string().trim().max(80).default(""),
  productReference: z.string().trim().max(240).optional(),
  concept: z.string().trim().min(3).max(500),
  hook: z.string().trim().min(3).max(240),
  script: z.string().trim().max(5_000).default(""),
  caption: z.string().trim().max(2_200).default(""),
  callToAction: z.string().trim().max(240).default(""),
  format: contentFormatSchema.default("product_demo"),
});

export type BrandProfileInput = z.input<typeof brandProfileInputSchema>;
export type ContentIdeaInput = z.input<typeof contentIdeaInputSchema>;
export type ContentFormat = z.infer<typeof contentFormatSchema>;
export type ContentStatus = z.infer<typeof contentStatusSchema>;
